import styled from "styled-components";

export const FormStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    margin-top: 10px;
  }

  h4 {
    align-self: flex-start;
  }

  a {
    margin: 0 0 20px 0;
  }

  textarea {
    margin: 0;
    max-height: 300px;
    resize: none;
  }

  @media (min-width: 768px) {
    grid-column: 3/4;
  }
`;

export const SettingsProfileGrid = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;

  button > img {
    margin-left: 10px;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 190px;

  img {
    margin-bottom: 0;
  }

  .icon {
    position: absolute;
    bottom: -10px;
    right: -10px;
  }
`;
